export default class ContentTemplateDomainService {
    static get Types() {
        return {
            GenericContentTemplate: 1,
            CampaignContentTemplate: 2,
        };
    }
    static fromJSON(json) {
        switch (json.typeId) {
            case ContentTemplateDomainService.Types.CampaignContentTemplate:
                return Object.assign({}, ContentTemplateDomainService.fromJSONGeneric(json));
            case ContentTemplateDomainService.Types.GenericContentTemplate:
            default:
                return ContentTemplateDomainService.fromJSONGeneric(json);
        }
    }
    static fromJSONGeneric(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate), expiredDate: json.expiredDate && new Date(json.expiredDate) });
    }
    static fromJSONLite(json) {
        return ContentTemplateDomainService.fromJSON(json);
    }
    // Meant to mirror same method in ContentTemplate.groovy
    static isMyTemplate(template, me) {
        if (template == null || me == null) {
            // We can't really determine if this is my template if template or me is null.  This is also helpful for
            // distinguishing between when the template isn't mine and when me or template are loading (and are therefore null)
            return null;
        }
        if (!template.createdBy) {
            // This hasn't been created by anyone, so it's up for grabs
            return true;
        }
        return template.createdBy.personId === me.id;
    }
}
